export const isValidCoordinate = (latLNg: [number, number]): boolean => {
    if (!Array.isArray(latLNg) || latLNg.length !== 2) {
        return false;
    }

    return latLNg[0] >= -180 && latLNg[0] <= 180 && latLNg[1] >= -90 && latLNg[1] <= 90;
};
